// import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { texto } from '@/shared';

import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { ICausalIncidencia } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { useCreateCausalIncidencia, useUpdateCausalIncidencia } from '@/shared/actions/erp/causal-incidentes';
import { useFetchCategoriaIncidentes } from '@/shared/actions/erp/categoria-incidentes';
import { useFetchSubcategoriaIncidencia } from '@/shared/actions/erp/subcategoria-incidentes';


const returnUrlCategoryProducto = '/tickets-soporte-cliente/causal-incidente';

export interface SaveCausalIncidenteInterface {
  titlePage: string;
  editCausalIncidencia?: ICausalIncidencia;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  estado: boolean;

  descripcion: string;
  categoria_incidencia: string;
  subcategoria_incidencia: string;
};

const SaveCausalIncidente: React.FC<SaveCausalIncidenteInterface> = ({
  titlePage,
  editCausalIncidencia,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* form
  const form = useForm<SaveFormData>({
    // resolver: yupResolver(newCausalIncidenteSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;


  //axios
  const { data: dataCatgoriaIncidentes, isLoading: isLoadingCategoriaIncident } = useFetchCategoriaIncidentes({ page_size: 600 })
  const { data: dataSubCategoriaIncidente, isLoading: isLoadingSubCate} = useFetchSubcategoriaIncidencia({ 
    page_size: 600, 
    categoria_incidencia: form.watch().categoria_incidencia, 
    enabled: !!form.watch().categoria_incidencia })
  ///* mutations
  const createCategoryProductMutation = useCreateCausalIncidencia({
    navigate,
    returnUrl: returnUrlCategoryProducto
  });
  const updateCategoryProductMutation = useUpdateCausalIncidencia({
    navigate,
    returnUrl: returnUrlCategoryProducto
  });



  ///* handlers
  const onSave = () => {
    if (!isValid) return;
    ///* upd
    if (editCausalIncidencia?.id_causal_incidencia) {
      return updateCategoryProductMutation.mutate({
        id: editCausalIncidencia.id_causal_incidencia,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCategoryProductMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editCausalIncidencia) {
      setShrink(true);
      reset(editCausalIncidencia as any);
    }
  }, [editCausalIncidencia]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCategoryProducto);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        name="codigo"
        label="Codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ""}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
      />
      <CustomTextField
        label={'Nombre'}
        name='nombre'
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message}
      />
      <CustomTextField
        name="descripcion"
        label="Descripción"
        control={form.control}
        defaultValue={form.getValues().descripcion || ""}
        error={errors.descripcion}
        helperText={errors.descripcion?.message}
        shrink={shrink}
      />
      <CustomAutocomplete
        label={texto.categoria_incidente}
        name='categoria_incidencia'
        options={dataCatgoriaIncidentes?.data.data || []}
        isLoadingData={isLoadingCategoriaIncident}
        defaultValue={form.getValues().categoria_incidencia || ''}
        valueKey={'nombre'}
        actualValueKey={'codigo'}
        control={form.control}
        onChangeValue={(_value)=>form.reset({
          ...form.getValues(),
          subcategoria_incidencia:undefined
        })}
        error={errors.categoria_incidencia}
        helperText={errors.categoria_incidencia?.message}
      />
      <CustomAutocomplete
        label={texto.subcategoria_incidente}
        name="subcategoria_incidencia"
        options={form.watch('categoria_incidencia') ? dataSubCategoriaIncidente?.data.data || [] : []}
        isLoadingData={isLoadingSubCate}
        defaultValue={form.getValues().subcategoria_incidencia || ''}
        valueKey={'nombre'}
        actualValueKey={'codigo'}
        control={form.control}
        error={errors.subcategoria_incidencia}
        helperText={errors.categoria_incidencia?.message}
        // disabled={!!!form.watch().categoria_incidencia}
      />
      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveCausalIncidente;
